import { render, staticRenderFns } from "./raffleIdentifier.vue?vue&type=template&id=763f3b78"
import script from "./raffleIdentifier.vue?vue&type=script&lang=js"
export * from "./raffleIdentifier.vue?vue&type=script&lang=js"
import style0 from "./raffleIdentifier.vue?vue&type=style&index=0&id=763f3b78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports